import { useMemo } from "react";
import { useAccount, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

export const useAuth = () => {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || null);

    return useMemo(
        () => ({
            isAuthenticated: accounts.length > 0,
            isInitialized: inProgress === InteractionStatus.None,
            user: account,
            instance,
        }),
        [accounts.length, account, instance, inProgress]
    );
};
